import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { Edit } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const useStyles = makeStyles((theme) => ({
  subscriptionInfo: {
    padding: '12px',
    marginLeft: 'auto',
  },
  title: {
    padding: '8px',
    paddingLeft: '12px',
    fontSize: 20,
  },
  infoTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  editButton: {
    color: 'rgba(0, 0, 0, 0.25)',
  },
  subscriptionTable: {
    borderCollapse: 'collapse',
    '& td, th': {
      border: '1px solid lightgray',
      padding: '5px 10px',
    },
  },
}));

const SubscriptionInfo = ({ subscriptionData, onEditOpen, children }) => {
  if (!subscriptionData) {
    return null;
  }

  const classes = useStyles();

  return (
    <Paper className={classes.subscriptionInfo} elevation={2} key="subscription-info">
      <div className={classes.infoTitle}>
        <Typography
          align="left"
          variant="h5"
          className={classes.title}
        >
          Subscription Info
        </Typography>
        <Tooltip title="Change subscription">
          <IconButton
            onClick={onEditOpen}
            className={classes.editButton}
            size="small"
          >
            <Edit />
          </IconButton>
        </Tooltip>
      </div>
      <table className={classes.subscriptionTable}>
        <thead>
          <tr>
            <th />
            <th>Current Cycle</th>
            {subscriptionData.hasNext && <th>Next Cycle</th>}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Paid Accounts</b></td>
            <td>{subscriptionData.currUserQuantity}</td>
            {subscriptionData.hasNext && <td>{subscriptionData.nextUserQuantity}</td>}
          </tr>
          <tr>
            <td><b>Available Accounts</b></td>
            <td>{subscriptionData.currQuantityAvailable}</td>
            {subscriptionData.hasNext && <td>{subscriptionData.nextQuantityAvailable}</td>}
          </tr>
          <tr>
            <td><b>Cycle End Date</b></td>
            <td>{subscriptionData.currEnd}</td>
            {subscriptionData.hasNext && <td>{subscriptionData.nextEnd}</td>}
          </tr>
        </tbody>
      </table>
      {children}
    </Paper>
  );
};

export default SubscriptionInfo;
